import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { API_BASE_URL } from './services/api';
import { installTenantHostHeader } from './services/tenantHost';

// The API cannot see which domain the browser is on once requests pass
// through the static site's rewrite, so every call carries it explicitly.
// Installed before the first render, so no request escapes it.
installTenantHostHeader(API_BASE_URL);

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  // TEMPORARILY DISABLED React.StrictMode to prevent double-rendering API calls in development
  // <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <App />
    </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
